import axiosInstance from "../../utils/axiosInstance";

const dashboardService = {

    getDashboard: async () => {

        const response = await axiosInstance.get("/Dashboard");

        return response.data;
    }

};

export default dashboardService;

